/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_CheckingInputs */

const th_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังตรวจสอบ…`)
};

const en_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

const ja_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認中…`)
};

const zh_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在检查…`)
};

const es_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobando…`)
};

const pt_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

const id_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa…`)
};

const fr_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification…`)
};

const tl_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusuri…`)
};

const vi_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra…`)
};

const ko_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인 중…`)
};

const de_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geprüft…`)
};

const ru_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверяем…`)
};

const tr_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetleniyor…`)
};

const it_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica in corso…`)
};

const pl_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdzanie…`)
};

const uk_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевіряємо…`)
};

const hi_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जाँचा जा रहा है…`)
};

const ar_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحقق…`)
};

const ms_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyemak…`)
};

const bn_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরীক্ষা করা হচ্ছে…`)
};

const zh_tw2_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢查中…`)
};

const zh_hk2_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢查中…`)
};

const ur_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جانچا جا رہا ہے…`)
};

const fa_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بررسی…`)
};

const sw_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inakaguliwa…`)
};

const nl_push_checking = /** @type {(inputs: Push_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met controleren…`)
};

/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Push_CheckingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_checking = /** @type {((inputs?: Push_CheckingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_CheckingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_checking(inputs)
	if (locale === "ja") return ja_push_checking(inputs)
	if (locale === "zh") return zh_push_checking(inputs)
	if (locale === "es") return es_push_checking(inputs)
	if (locale === "pt") return pt_push_checking(inputs)
	if (locale === "id") return id_push_checking(inputs)
	if (locale === "fr") return fr_push_checking(inputs)
	if (locale === "tl") return tl_push_checking(inputs)
	if (locale === "vi") return vi_push_checking(inputs)
	if (locale === "ko") return ko_push_checking(inputs)
	if (locale === "de") return de_push_checking(inputs)
	if (locale === "ru") return ru_push_checking(inputs)
	if (locale === "tr") return tr_push_checking(inputs)
	if (locale === "it") return it_push_checking(inputs)
	if (locale === "pl") return pl_push_checking(inputs)
	if (locale === "uk") return uk_push_checking(inputs)
	if (locale === "hi") return hi_push_checking(inputs)
	if (locale === "ar") return ar_push_checking(inputs)
	if (locale === "ms") return ms_push_checking(inputs)
	if (locale === "bn") return bn_push_checking(inputs)
	if (locale === "zh-TW") return zh_tw2_push_checking(inputs)
	if (locale === "zh-HK") return zh_hk2_push_checking(inputs)
	if (locale === "ur") return ur_push_checking(inputs)
	if (locale === "fa") return fa_push_checking(inputs)
	if (locale === "sw") return sw_push_checking(inputs)
	if (locale === "nl") return nl_push_checking(inputs)
	return en_push_checking(inputs)
});